<template>
  <div class="no-axis-line-chart">
    <div class="chart_box" ref="chart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'NoAxisLineChart',
  props: {
    data: {
      type: Array,
      default: () => [120, 200, 150, 80, 70, 110, 130]
    },
    lineColor: {
      type: String,
      // default: '#409EFF'
      default:'#2C5844',
    },
    areaColor: {
      type: String,
      // default: '#00ff00'
      default:'#000',
    },
    smooth: {
      type: Boolean,
      default: true
    },
    showSymbol: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.updateChart();
      }
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.setChartOption();
    },
    setChartOption() {
      const option = {
        // 隐藏所有坐标轴
        xAxis: {
          show: false,
          type: 'category',
          boundaryGap: false,
        },
        yAxis: {
          show: false
        },
        // 隐藏网格线
        grid: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: false
        },
        // 隐藏图例
        legend: {
          show: false
        },
        // 禁用工具箱
        toolbox: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return (
                ''+ params[0].data+"%"
            );
          },
          backgroundColor:"transparent",
          borderColor:"transparent",
          textStyle:{
            color:"#fff"
          },
          axisPointer: {
            animation: true
          }
        },
        // 设置系列数据
        series: [{
          type: 'line',
          data: this.data,
          smooth: this.smooth,
          showSymbol: this.showSymbol,
          symbolSize: 8,
          lineStyle: {
            width: 1,
            color: this.lineColor
          },
          itemStyle: {
            color: this.lineColor
          },
          // areaStyle: {
          //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //     { offset: 0, color: this.areaColor },
          //     { offset: 1, color: 'rgba(255, 255, 255, 0)' }
          //   ])
          // }
        }]
      };
      this.chart.setOption(option);
    },
    updateChart() {
      if (this.chart) {
        this.chart.setOption({
          series: [{
            data: this.data
          }]
        });
      }
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>

<style scoped>
.no-axis-line-chart {
  width: 100%;
  height: 100%;
  background: transparent;
}
.chart_box{
  width:100px;
  height: 52px;
  padding-top: 10px
}
@media (max-width: 750px) {
  .chart_box{
    height: 80px!important;
  }
}
@media (max-width: 1200px) {
  .chart_box{
    width: 100%;
    height: 200px;
    min-height: 70px;
    padding-top: 0;
  }
}
</style>
